import { roundToTwo } from "./Stats";


export function displayTopResultOfTask(ind:number, points:number, possible:number){

    const html = '<div class="p-center">' + 
    '<h3 class="fragen-nummer">Aufgabe ' + ind + '<br><br> ' + roundToTwo(points) + ' / ' + roundToTwo(possible) + ' Punkten</h3>' + 
    '</div>' + 
    '<hr>';

    return html;
}